/* eslint-disable import/prefer-default-export */
import React from 'react'

import s from './WeWereFeatured.module.css'

import nyTimes from './assets/newYorkTimes.png'
import vice from './assets/vice.png'
import theWebby from './assets/theWebby.png'
import dwell from './assets/dwell.png'

const BRANDS = [
  {
    name: 'The New York Times',
    image: nyTimes,
  },
  {
    name: 'Vice',
    image: vice,
  },
  {
    name: 'The Webby Awards',
    image: theWebby,
  },
  {
    name: 'DWELL',
    image: dwell,
  },
]

export function WeWereFeatured() {
  return (
    <div className={s.root}>
      <div className={s.title}>We were featured on</div>

      <div className={s.list}>
        {BRANDS.map((brand) => (
          <div className={s.brand}>
            <img src={brand.image} alt={brand.name} className={s.brandImage} />
          </div>
        ))}
      </div>
    </div>
  )
}
